import React from 'react'

import InfoModal from 'Components/InfoModal'

const NutritionAnalysisInfo = (): JSX.Element => (
  <InfoModal>
    <h2>Das Nährwertdiagramm</h2>
    <p>
      Um gesund abzunehmen, spielt nicht nur die Menge, sondern auch die Zusammensetzung der Ernährung eine Rolle. Die
      Zufuhr aller lebensnotwendigen Makronährstoffe (Kohlenhydrate, Protein und Fett), Wirkstoffe (Vitamine,
      Mineralstoffe, Spurenelemente) und bioaktiven Substanzen ist nur dann gewährleistet, wenn die Menuplanung
      abwechslungsreich und vielseitig ist. Die Schweizerische Gesellschaft für Ernährung (SGE/SSN) empfiehlt deshalb
      die folgende Nährstoffverteilung:
    </p>
    <p>
      50 % der Kalorien stammen aus Kohlenhydraten (besonders aus Getreideprodukten, Kartoffeln, Früchten, Gemüse und
      Milchzucker). Davon mindestens 30 g (60 kcal) in Form von Nahrungsfasern und maximal 10 % aus zugesetztem Zucker.
    </p>

    <p>
      Unter zugesetztem Zucker werden Zucker wie Glucose, Fructose, Saccharose usw. verstanden, die vom Hersteller oder
      Konsumenten zur Süssung eines Lebensmittels hinzugefügt worden sind. Dazu zählen auch Zucker aus Honig,
      verschiedene Siruparten, Säften und Saftkonzentraten. Beachten Sie: Die Zuckerangabe in der Nährwertdeklaration
      bezieht sich auf den Gesamtzucker, einschliesslich aller natürlich vorkommenden Zucker wie in Früchten, Gemüse
      oder Milch, die nicht als zugesetzter Zucker gelten.
    </p>
    <p>30 % der zugeführten Kalorien stammen aus Fett (vorzugsweise pflanzliche Produkte).</p>
    <p>
      20 % der Kalorien werden durch Protein zugeführt (Fleisch, Fisch, Eier, Milchprodukte, Hülsenfrüchte und
      Getreide).
    </p>
    <p>Zusätzlich sollte die Salzzufuhr nicht mehr als 5 g pro Tag betragen.</p>
    <p>
      Die Menugestaltung sollte so erfolgen, dass sich die Nährstoffbilanz innerhalb von 14 Tagen ausgleicht - ein
      täglich korrektes Diagramm ist unrealistisch und nicht nötig.
    </p>
    <p>
      Wichtig: Proteine und Kohlenhydrate liefern pro Gramm ca. 4 Kalorien, 1 Gramm Fett hingegen etwa 9 Kalorien - mehr
      als das Doppelte. Das ist der Grund, warum die Fetteinsparung beim Abnehmen so wichtig ist und das Diagramm beim
      Fettanteil immer so schnell zunimmt.
    </p>
    <p>
      Weil sich die Darstellung im Kreisdiagramm immer auf den momentanen Stand bezieht und die Prozente in der Summe
      100 ergeben müssen, entsteht oft eine vermeintliche Fehlanzeige. Wenn bei einem Fettguthaben von 54 g erst 32 g
      Fett «bezogen» wurden, kann der Fettanteil, je nach Nahrungszusammensetzung, für den Moment 35 % ausmachen. Die
      Grammangaben sind exakt für Sie, auf Ihren individuellen täglichen Kalorienbedarf, berechnet. Die Fitnesskalorien
      haben nur auf die Gesamtkalorien Einfluss, nicht aber auf die Nährwerte.
    </p>
    <h3>Achtung bei direkten Einträgen</h3>
    <p>
      Sollten Sie in Ihrem Tagebuch einen direkten Kalorieneintrag getätigt haben, beachten Sie bitte Folgendes: Zu
      diesem Eintrag bestehen keine Angaben zu der Verteilung der einzelnen Nährwerte, weshalb er in der Anzeige des
      Nährwertdiagramms nicht berücksichtigt werden kann. Das Nährwertdiagramm spiegelt nur jene Eintragungen wider,
      welche aus der eBalance-Datenbank stammen oder die Nahrungsmittel/Rezepte, welche Sie selbst mit den
      entsprechenden Nährwerten in der Datenbank erfasst haben.
    </p>
    <p>
      Sollten Sie die Verteilung der Nährwerte zu Ihrem freien Kalorieneintrag kennen, können Sie diese als
      Nahrungsmittel oder Rezept erfassen und so ins Tagebuch übertragen. So kann der Eintrag auch bei der Anzeige des
      Nährwertdiagramms berücksichtigt werden.
    </p>
  </InfoModal>
)

export default NutritionAnalysisInfo
